import { AlertCircle } from "lucide-react"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"

interface ErrorStateProps {
  errorMessage?: string
}

export default function ErrorState({ errorMessage = "Preview not found" }: ErrorStateProps) {

  return (
    <div className="flex-1 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>
            {errorMessage}. The link may be invalid or the preview has been removed. contact us on info@atlasimex.es
          </AlertDescription>
        </Alert>
      </div>
    </div>
  )
}

